import { Avatar, Box, Button, FormControl, TextField, Typography } from '@mui/material'
import { useLocation } from 'react-router-dom'
import { useGetCompanyDescriptionQuery } from '../../store/api/backoffice/backofficeDetailApi'
import { AppDispatch, RootState } from '../../store/store'
import { useDispatch, useSelector } from 'react-redux'
import { BackofficeCompanyDetailState, handleData } from '../../store/slices/backoffice/backofficeCompanyDetailSlice'
import BackOfficeContacts from './BackOfficeContacts'

function BackOfficeCompanyProfile() {
	const location = useLocation()
	const dispatch = useDispatch<AppDispatch>()
	const companyDetail: BackofficeCompanyDetailState = useSelector((state: RootState) => state.backofficeCompanyDetail)
	const { data: companyDetails } = useGetCompanyDescriptionQuery(location.state.companyDatabaseId)

	const regexNoCharSymb = /[a-zA-Z$&+,:;=?@#|'<>-^*()%!-çªº*]/
	const regexNoSymb = /[$&+,:;=?@#|'<>-^*()%!]/

	const handleLogoUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
		const file = event.target.files?.[0]
		if (file) {
			const reader = new FileReader()
			reader.onloadend = () => {
				const base64String = reader.result as string
				dispatch(
					handleData({
						...companyDetail,
						data: {
							...companyDetail.data,
							companyLogo: base64String,
						},
					}),
				)
			}
			reader.readAsDataURL(file)
		}
	}

	const handleChange = (field: string) => (event: React.ChangeEvent<HTMLInputElement>) => {
		const value = event.target.value

		// // Validação específica para cada campo
		// if (field === 'companyName' || field === 'companyObservation') {
		//   if (!regexNoSymb.test(value)) {
		//     event.preventDefault();
		//     return;
		//   }
		// } else if (field === 'companyId' || field === 'companyAbbreviation') {
		//   if (!regexNoCharSymb.test(value)) {
		//     event.preventDefault();
		//     return;
		//   }
		// }

		dispatch(
			handleData({
				...companyDetail,
				data: {
					...companyDetail.data,
					[field]: value,
				},
			}),
		)
	}

	return (
		<Box sx={{ display: 'flex', justifyContent: 'center', marginBlockStart: '1rem', width: '100%' }}>
			<Box sx={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', width: '85%' }}>
				<Typography variant='h5'>Dados de Empresa</Typography>
				<Box sx={{ display: 'flex', justifyContent: 'flex-start', marginBlock: '0.5rem' }}>
					<Avatar
						src={companyDetail?.data?.companyLogo || undefined}
						sx={{
							borderRadius: '100%',
							display: 'flex',
							flexDirection: 'column',
							alignItems: 'center',
							justifyContent: 'center',
							bgcolor: 'lightgrey 50% / cover no-repeat',
							width: 32,
							height: 32,
							fontSize: '20px',
							fontWeight: 400,
							lineHeight: 1,
						}}
					/>
					<Button
						variant='text'
						component='label'
					>
						Adicionar Logotipo +
						<input
							type='file'
							hidden
							accept='image/*'
							onChange={handleLogoUpload}
						/>
					</Button>
				</Box>
				<Box sx={{ display: 'flex', flexWrap: '', margin: '0.5rem 0.2rem' }}>
					<FormControl sx={{ minWidth: 120, width: '100%', display: 'flex', flexDirection: 'column' }}>
						<TextField
							size='small'
							onChange={handleChange('companyName')}
							value={companyDetail?.data?.companyName ?? ''}
							label='Nome da Empresa'
							variant='outlined'
							sx={{ width: '100%' }}
							inputProps={{ maxLength: 255 }}
							error={!companyDetail?.data?.companyName}
						/>
					</FormControl>
				</Box>
				<Box sx={{ display: 'flex', flexWrap: '', margin: '0.2rem 0rem' }}>
					<FormControl sx={{ minWidth: 120, width: '100%', display: 'flex' }}>
						<Box sx={{ display: 'flex', width: '100%' }}>
							<TextField
								size='small'
								value={companyDetail?.data?.companyAbbreviation ?? ''}
								onChange={handleChange('companyAbbreviation')}
								label='Abreviatura / Nome de Ecrã'
								variant='outlined'
								sx={{ margin: '0.2rem', width: '50%' }}
							/>
							<TextField
								size='small'
								value={companyDetail?.data?.companyId ?? ''}
								onChange={handleChange('companyId')}
								label='ID'
								variant='outlined'
								sx={{ margin: '0.2rem', width: '50%' }}
							/>
						</Box>
					</FormControl>
				</Box>
				<Box sx={{ display: 'flex', flexWrap: '', margin: '0.2rem 0.2rem', marginBlockStart: '0.4rem' }}>
					<FormControl
						sx={{ minWidth: 120, width: '100%', display: 'flex', flexDirection: 'column' }}
						size='small'
					>
						<TextField
							onChange={handleChange('companyObservation')}
							label='Observações'
							value={companyDetail?.data?.companyObservation ?? ''}
							variant='outlined'
							size='medium'
							multiline={true}
							sx={{ width: '100%' }}
						/>
					</FormControl>
				</Box>
				<BackOfficeContacts />
			</Box>
		</Box>
	)
}

export default BackOfficeCompanyProfile
